import {
    Component,
    OnInit,
    AfterViewInit, OnDestroy,
    Input,
    ViewChild,
    Renderer2,
    HostListener, ElementRef
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {SlickGridComponent} from 'app/slick-grid/slick-grid.component';
import {StocksService} from 'app/stocks/services/stocks.service';
import {StocksFilter} from 'app/stocks/models/stocks-filter';
import {CommonDataService} from 'app/services/common-data.service';
import {StocksFilterService} from "app/stocks/services/stocks-filter.service";
import {ISubscription} from "rxjs/Subscription";
import { FilterType5 } from 'app/stocks/models/filter-type-5';
import {StocksFiltersState, StocksFiltersStateGUID} from "../../models/stocks-filters-state";
import {SelectedFilter, SelectedFilterGUID} from "../../models/selected-filter";
import {ClearSelected, ClearSelectedGUID} from "../../models/clear-selected";
import {BlockFilter, BlockFilterGUID} from "../../models/block-filter";
import {Focus} from "../../models/focus";
import {StocksHelper} from "../../models/stocks-helper";
import {StocksFilterGUID} from "../../models/stocks-filter";

type InitialData = { accessDenied: boolean, rights: any };

@Component({
    selector: 'number-filter',
    templateUrl: './number-filter.component.html',
    styleUrls: ['./number-filter.component.css']
})
export class NumberFilterComponent implements OnInit, AfterViewInit, OnDestroy{

    constructor(public readonly translateService: TranslateService,
                private readonly renderer: Renderer2,
                private readonly stocksService: StocksService,
                public readonly commonData: CommonDataService,
                private filterService: StocksFilterService){

        this.initialise();
        this.helper = new StocksHelper();
    }

    private initialise = (): void =>{
        this.allItemsQuantity = 0;
        this.selectedQuantity = 0;
        this.develop = false;
        this._inputData = null;
        this._inputData2 = null;
        this._inputType = '1';
        this.messageTop = 0;
        this.selected = false;
        this.blockFilter = false;
    };

    @HostListener('window:mousedown', ['$event']) onMouseDown(e: MouseEvent){
        this.hideGridOnClick(e);
    }

    @HostListener('window:keydown', ['$event']) onKeyDown(e: KeyboardEvent){
        this.handleKeys(e, true);
    }

    @HostListener('window:keyup', ['$event']) onKeyUp(e: KeyboardEvent){
        this.handleKeys(e, false);
    }

    @Input() param: string;
    @Input() type: number;
    @Input() separator: string[];
    @Input() position: number;
    @Input() GUID: string;
    //@Input() level?: number;

    @ViewChild('inputDataEl')
    private inputDataEl: ElementRef;

    @ViewChild('inputDataEl2')
    private inputDataEl2: ElementRef;

    @ViewChild('inputDataEl3')
    private inputDataEl3: ElementRef;

    @ViewChild('select')
    private select: ElementRef;

    @ViewChild('inputSearchEl')
    private inputSearchEl: ElementRef;

    @ViewChild('gridWrpEl')
    private gridWrpEl: ElementRef;

    @ViewChild('showSearchEl')
    private showSearchEl: ElementRef;

    @ViewChild('mainWrapper')
    private mainWrapper: ElementRef;

    @ViewChild('clearDataFilterEl')
    private clearDataFilterEl: ElementRef;

    private filter: StocksFilter;
    public _inputData: string;
    public _inputData2: string;
    public _inputData3: string;
    public _inputType: string;
    public mouseDown: boolean;
    private allItemsQuantity: number;
    private selectedQuantity: number;
    private subscription: ISubscription;
    private focusActive: boolean;
    private focusActive2: boolean;
    private focusActive3: boolean;
    private focusSearchActive: boolean;
    private ctrlPressed: boolean;
    private plusPressed: boolean;
    private develop: boolean;
    private wrongData: boolean;
    private subscriptionState: ISubscription;
    private subscriptionFill: ISubscription;
    private filtersState: StocksFiltersState;
    private subscriptionSelectedFilter: ISubscription;
    private subscriptionClearSelectedFilter: ISubscription;
    private subscriptionClearFilter: ISubscription;
    private subscriptionSetFocus: ISubscription;
    private subscriptionBlockFilter: ISubscription;
    private subscriptionScroll: ISubscription;
    public wrpClass: any;
    private messageTop: number;
    private selectedFilters: any;
    public selected: boolean;
    public blockFilter: boolean;
    public messageShowScroll: boolean;
    private helper: StocksHelper;


    ngOnInit(){


        this.subscription = this.filterService.stocksFilterCurrent.subscribe((res: StocksFilterGUID[]) => {
            this.helper.tryCatch(() => {
                let found: StocksFilterGUID = this.helper.getGUIDObj(res, this.GUID);
                if (found && !this.helper.compareSimpleObj(this.filter, found.stocksFilter)){
                    this.filter = found.stocksFilter;
                }
            })
        });

        this.subscriptionState = this.filterService.stocksFiltersStateCurrent.subscribe((res: StocksFiltersStateGUID[]) =>{
            this.helper.tryCatch(() => {
                let found: StocksFiltersStateGUID = this.helper.getGUIDObj(res, this.GUID);
                if (found && !this.helper.compareSimpleObj(this.filtersState, found.stocksFiltersState)){
                    this.filtersState = found.stocksFiltersState
                }
            })
        });

        this.subscriptionFill = this.filterService.fillFilterCurrent.subscribe((res: {GUID: string, fillFilter: boolean}) =>
            this.helper.tryCatch(() => res && res.GUID === this.GUID ? this.fillFilter = res.fillFilter : null)
        );

        this.subscriptionSelectedFilter = this.filterService.selectedFiltersCurrent.subscribe((res: SelectedFilterGUID) => {
            this.helper.tryCatch(() => {
                if (res && res.GUID === this.GUID ){
                    this.selectedFilters = res.selectedFilters
                }
            })
        });

        this.subscriptionClearSelectedFilter = this.filterService.clearSelectedFilterCurrent.subscribe((res: ClearSelectedGUID) => {
            this.helper.tryCatch(() => {
                if (res && res.GUID === this.GUID ){
                    this.clearSelectedFilter = res.clearSelected
                }
            })
        });

        this.subscriptionClearFilter = this.filterService.clearFilterCurrent.subscribe((res: {GUID: string, command: string}) =>
            this.helper.tryCatch(() => res && res.GUID === this.GUID ? this.clearFilter = res.command : null)
        );

        this.subscriptionSetFocus = this.filterService.goToNextFilterCurrent.subscribe((res: {GUID: string, param: string}) =>
            this.helper.tryCatch(() => res && res.GUID === this.GUID ? this.setFocus = res.param : null)
        );

        this.subscriptionBlockFilter = this.filterService.blockFilterCurrent.subscribe((res: BlockFilterGUID) =>
            this.helper.tryCatch(() => res && res.GUID === this.GUID ? this.block = res.blockFilter : null)
        );

        this.subscriptionScroll = this.filterService.filtersScrollCurrent.subscribe(res => this.helper.tryCatch(() => this.scrollPosition = res));
        this.wrpClass = this.generateWrpClass()
    }

    ngOnDestroy(){
        this.subscription.unsubscribe();
        this.subscriptionState.unsubscribe();
        this.subscriptionFill.unsubscribe();
        this.subscriptionSelectedFilter.unsubscribe();
        this.subscriptionClearSelectedFilter.unsubscribe();
        this.subscriptionClearFilter.unsubscribe();
        this.subscriptionSetFocus.unsubscribe();
        this.subscriptionBlockFilter.unsubscribe();
        this.subscriptionScroll.unsubscribe();
    }

    ngAfterViewInit(){

        let timeout = setTimeout(() => {
            clearTimeout(timeout);
            timeout = null;
            this.setMessageTop();
        },0);

    }

    public set fillFilter (fill: boolean){
        if (fill && this.type === 5 && this.filter[this.param].operation !== 0) {
            let inputType = this.filter[this.param].operation,
                inputData = this.filter[this.param].values[0],
                inputData2 = this.filter[this.param].values[1];
            this.inputType = inputType.toString();
            this.inputData = inputData.toString();
            this.inputData2 = inputData2.toString();
        } else if (fill && this.type === 3 && this.filter[this.param] && this.filter[this.param].length > 0){
            this.inputData3 = this.getStringFromArr(this.filter[this.param]);
        }
        this.isSelected();
    }

    private set clearSelectedFilter(clearFilter: ClearSelected){
        //if (this.develop) console.log(clearFilter, 'clearFilter');
        if (clearFilter && this.param === clearFilter.name) {
            if (clearFilter.clearAll) {
                this.clearDataFilter();
            } else {

            }
        }
    }

    private set clearFilter(command: string){
        if (command === 'clear'){
            this.clearDataFilter();
            this.initialise();
        }
    }

    public set setFocus(param: string){
        if (this.param === param){
            setTimeout(() => {
                this.type === 3 ? this.inputDataEl3.nativeElement.focus() : this.select.nativeElement.focus();
            }, 0)
        }
    }

    public set block(value: BlockFilter){
        if (value && value.param !== this.param){
            this.blockFilter = value.block;
        }
    }

    public set inputData (data: string){
        if (this._inputData !== data) {
            this._inputData = data;
        }
    }

    /*private customParseNumber = (data: string): number => {
        let res: number;
        if (data) data = data.replace(/,/g, '.');
        res = data === '' ? null : Number(data);
        // res = isNaN(res) || data === null ? null : res;
        return data === null ? null : res;
        //return res;
    };*/

    public get inputData (){
        return this._inputData
    }

    public set inputData2 (data: string){
        if (this._inputData2 !== data) {
            this._inputData2 = data;
        }
    }

    public get inputData2 (){
        return this._inputData2;
    };

    private set scrollPosition(value: number){
        if (value !== null){
            if (this.wrongData) {
                this.setMessageTop();
            }
        }
    };

    private validateData = (): boolean => {
        // if (this.develop) console.log(this.inputData, 'this.inputData', this.inputData2, 'this.inputData2', this.param);
        // if (this.develop) console.log(this.customParseNumber(this.inputData), 'this.inputData', this.customParseNumber(this.inputData2), 'this.inputData2', this.param);

        if (this.type === 3) {
            let arr = this.getArrFromString(this.inputData3).filter(item => item);
            if (this.develop) console.log(arr, 'validateData', this.param);
                return arr.some(item => !this.helper.customParseNumber(item))
        } else if (this.type === 5) {
            if (this.helper.customParseNumber(this.inputData) === null && this.helper.customParseNumber(this.inputData2) === null) {
                return false;
            }

            if (isNaN(this.helper.customParseNumber(this.inputData)) || isNaN(this.helper.customParseNumber(this.inputData2))){
                return true;
            }

            return this.inputType === '7' ? this.helper.customParseNumber(this.inputData) >= this.helper.customParseNumber(this.inputData2) ||
                this.helper.customParseNumber(this.inputData) === null && this.helper.customParseNumber(this.inputData2) !== null ||
                this.helper.customParseNumber(this.inputData2) === null && this.helper.customParseNumber(this.inputData) !== null
                : false;
        }

    };

    private needUpdateStocksFilter = (): boolean => {
        if (this.type === 3) {
            let arr = this.getArrFromString(this.inputData3),
                numArr = arr.map(item => this.helper.customParseNumber(item));
            numArr = numArr.filter(item => item);
            return !this.compareArr(this.sortArr(numArr), this.sortArr(this.filter[this.param]))
        } else if (this.type === 5) {
            let values: number[] = [this.helper.customParseNumber(this.inputData), this.helper.customParseNumber(this.inputData2)],
                operation = Number(this.inputType);

            if (this.filter[this.param].operation === 0 &&
                this.filter[this.param].values === null &&
                operation === 1 && values[0] === null && values[1] === null
            ) return false;

            if (this.filter[this.param].values === null &&
                values[0] === null && values[1] === null
            ) return false;

            if (this.filter[this.param].operation !== operation ||
                this.filter[this.param].values[0] !== values[0]
            ) return true;

            if (operation === 7) {
                if (this.filter[this.param].values[1] !== values[1]) return true;
            }

            return false;
        }
    };

    private updateStocksFilter = (): void => {
        if (this.type === 3) {
            if (this.inputData3 && this.getArrFromString(this.inputData3).length > 0) {
                let arr = this.getArrFromString(this.inputData3);
                this.filter[this.param] = arr.map(item => this.helper.customParseNumber(item)).filter(item => item);
                this.selectedQuantity = this.filter[this.param].length;
            } else {
                this.nullStocksFilter();
            }
        } else if (this.type === 5) {
            let values: number[] = [this.helper.customParseNumber(this.inputData), this.helper.customParseNumber(this.inputData2)],
                operation = Number(this.inputType);
            if (values && values[0] !== null && operation !== 0 && !this.wrongData){
                let filterData: FilterType5 = new FilterType5();
                filterData.values = values;
                if (operation !== 7) filterData.values[1] = 0;
                filterData.operation = operation;
                this.filter[this.param] = filterData;
            } else {
                this.nullStocksFilter();
            }
        }

        this.filterService.setFilter({ GUID: this.GUID, stocksFilter: this.filter });
        this.filterService.updateFiltersState({ GUID: this.GUID, prop: this.param });
        if (this.develop) console.log(this.filter, 'updateStocksFilter', this.param)
    };

    private nullStocksFilter = (updateState?: boolean): void =>{
        if (this.type === 3) {
            this.filter[this.param] = null;
        } else if (this.type === 5){
            let filterData: FilterType5 = new FilterType5();
            filterData.values = null;
            filterData.operation = 0;
            this.filter[this.param] = filterData;
        }
        if (updateState) this.filterService.updateFiltersState({ GUID: this.GUID, prop: this.param });
    };

    private updateSelectedFilter = async (): Promise<void> => {

        if (this.selected) {
            let selectedFilter: SelectedFilter = new SelectedFilter(this.param, this.type, this.position);


            if (this.type === 3) {
                selectedFilter.dataString = this.inputData3;
            } else {
                let type;
                switch (this.helper.customParseNumber(this.inputType)){
                    case 1: type = '='; break;
                    case 2: type = '≠'; break;
                    case 3: type = '<'; break;
                    case 4: type = '≤'; break;
                    case 5: type = '≥'; break;
                    case 6: type = '>'; break;
                    case 7: type = await this.translateService.get('Between').toPromise(); break;
                }
                if (this.inputType === '7') {
                    type += ' ' + this.inputData + ' - ' + this.inputData2;
                } else {
                    type += ' ' + this.inputData;
                }
                selectedFilter.dataString = type;
            }
            this.selectedFilters = selectedFilter;
            // this.selectedFilters[this.param] = selectedFilter;
        } else {
            this.selectedFilters = new SelectedFilter(this.param, this.type, this.position);
            // delete this.selectedFilters[this.param];
        }

        this.filterService.setSelectedFilters({ GUID: this.GUID, selectedFilters: [this.selectedFilters] });
        if(this.develop) console.log(this.selectedFilters, 'updateSelectedFilter')
    };

    public set inputType (data: string){
        if (this._inputType !== data){
            this._inputType = data;
            if (data !== '7') this.inputData2 = '';
            if (this.develop) console.log(data);
        }
    }

    public get inputType (){
        return this._inputType
    }

    public set inputData3 (data: string){
        if (this._inputData3 !== data) {
            this._inputData3 = data;
        }
    }

    public get inputData3 (){
        return this._inputData3;
    };

    public onBlur = (data: number): void => {
        console.log('onBlur', this.param);

        if (data === 1) {
            this.focusActive = false;
        } else if (data === 2) {
            this.focusActive2 = false;
        } else if (data === 3) {
            this.focusActive3 = false;
        }
    };

    public onFocus = (data: number): void => {
        console.log('onFocus', this.param);
        if (data === 1) {
            this.focusActive = true;
        } else if (data === 2) {
            this.focusActive2 = true;
        } else if (data === 3) {
            this.focusActive3 = true;
        }
        this.wrongData = false;
    };

    private setFocusWithTimeout = (): void => {
        console.log('setFocusWithTimeout');
        if (this.type !== 4){
            let timeOut = setTimeout(() => {
                this.inputSearchEl.nativeElement.focus();
                clearTimeout(timeOut);
                timeOut = null;
            }, 50);
        }
    };

    private hideGridOnClick = (e: MouseEvent): void =>{

            if (!e.target) return;

            let target = e.target;

            if (this.inputDataEl && this.inputDataEl.nativeElement.isSameNode(target) ||
                this.inputDataEl2 && this.inputDataEl2.nativeElement.isSameNode(target) ||
                this.inputDataEl3 && this.inputDataEl3.nativeElement.isSameNode(target) ||
                this.clearDataFilterEl && this.clearDataFilterEl.nativeElement.isSameNode(target) ||
                this.select && this.select.nativeElement.isSameNode(target) ||
                this.checkPrent(this.clearDataFilterEl, target, true)
            ) return;

            this.messageShowScroll = this.wrongData = this.validateData();
            this.setMessageTop();
            this.updateSubscriptions();

    };

    private checkPrent = (el: ElementRef, target: any, same: boolean): boolean => {
        let parent = target.parentElement;
        if (el && el.nativeElement && parent) {

            let parent = target.parentElement;
            return same ? parent.isSameNode(el.nativeElement) : parent === el.nativeElement;
        }
        return false;
    };

    private isSelected = (): void => {
        if (this.type === 3) {
            this.selected = !!this.filter[this.param];
        } else {
            this.selected = !!this.filter[this.param].values;
        }
    };

    private compareArr = (arr1: number[], arr2: number[]): boolean =>{
        if (!arr1 || !arr2)
            return false;

        // compare lengths - can save a lot of time
        if (arr1.length != arr2.length)
            return false;

        for (let i = 0, l = arr1.length; i < l; i++) {

            if (arr1[i] !== arr2[i]) {
                // Warning - two different object instances will never be equal: {x:20} != {x:20}
                return false;
            }
        }
        return true;

    };

    private sortArr = (arr: number[]): number[] => {
        if (!arr) return [];
        return arr.sort();
    };

    private handleKeys = (e: KeyboardEvent, keyDown: boolean): void =>{

        if (this.plusPressed && this.plusPressed && !keyDown){
            if (this.focusActive) console.log('ctrl+');
        }

        if (!keyDown && e.keyCode === 13) {
            if (this.focusActive || this.focusActive2 || this.focusActive3){

                this.messageShowScroll = this.wrongData = this.validateData();
                this.setMessageTop();
                this.updateSubscriptions();
            }
        }

        if (keyDown && e.keyCode === 9 && this.focusSearchActive) {
            e.preventDefault();
            this.inputDataEl.nativeElement.focus();
            this.focusSearchActive = false;
        }

        if (e.ctrlKey ) this.ctrlPressed = keyDown;
        if (e.keyCode === 107) this.plusPressed = keyDown;

    };

    private onlyUnique = (value, index, self): boolean => {
        return value ? self.indexOf(value) === index : false;
    };



    public addSelected = (): void =>{
        if (this.inputData){
            console.log('addSelected');

            let inputDataArr = this.getArrFromString(this.inputData);
            //if (inputDataArr.length > 0) inputDataArr.pop();

            inputDataArr = inputDataArr.filter(this.onlyUnique);
            this.inputData = this.getStringFromArr(inputDataArr);
            //this.syncSelected();
            //this.inputData ? this.inputData += ', ' : '';

            //this.setSelectedQuantity();

        } else {
            this.clearDataFilter();
        }
        this.inputDataEl.nativeElement.focus();
    };

    private setSelectedQuantity = (): void => {
        // console.log(this.data.filter(item => item.selected).length, 'setSelectedQuantity');
        // this.selectedQuantity = this.data.filter(item => item.selected).length;
    };

    private getArrFromString = (data: string): string[] => {
        return data ? data.split(this.separator[0]).map(item => item.trim()): [];
    };

    private getStringFromArr = (data: string[]): string => {
        return data.map((item, i) => i === 0 ? item : ' ' + item).join(this.separator[0]);
    };

    public clearDataFilter = () => {
        if (this.develop) console.log('clearDataFilter');
        if (this.type === 5) {
            this.inputData = '';
            this.inputData2 = '';
            //this.inputType = '1';

        } else if (this.type === 3 ) {
            this.inputData3 = '';
            this.selectedQuantity = 0;
        }

        this.wrongData = false;
        this.updateSubscriptions();
        //this.nullStocksFilter(true);
    };

    private updateSubscriptions = (): void => {
        if (!this.wrongData && this.needUpdateStocksFilter()){
            this.updateStocksFilter();
            this.isSelected();
            this.updateSelectedFilter().then();
            this.getAdditionalData();
        }
    };

    private getAdditionalData = (): void =>{
        console.log(this.param, 'getAdditionalData start');
        let param = this.helper.needGetAdditionalData(this.filter) ? this.param : 'cancelUpdate';
        this.filterService.setGetAdditionalData({ GUID: this.GUID, param: param, filter: this.filter});
    };

    public inputDataWork = (e?: KeyboardEvent): void => {
        if (e && e.keyCode === 27){
            this.clearDataFilter();
            return;
        }

        if (e && (e.keyCode === 37 || e.keyCode === 39 || e.keyCode === 17 || e.keyCode === 13 )) return;
    };


    private generateWrpClass = (): any =>{
        let classes: any = {wrp: true};
        switch (this.type){
            case 3:
                classes['type-3'] = true;
                break;
            case 5:
                classes['type-5'] = true;
                break;
        }
        return classes;
    };

    /*private setMessageTop = (): void => {
        let $mainWrapper = $(this.mainWrapper.nativeElement.parentElement);
        this.messageTop = $mainWrapper.position().top - 24;
    };*/

    private setMessageTop = (): void => {
        if (this.wrongData) {
            let $modalBody = $('.modal-body'),
                modalBodyH = $modalBody.outerHeight(),
                filtersWrpH = $('.filters-wrp').outerHeight(),
                modalBodyP = parseInt($modalBody.css("padding-bottom")),
                $mainWrapper = $(this.mainWrapper.nativeElement.parentElement);

            let show1 = modalBodyH - modalBodyP - filtersWrpH - $mainWrapper.position().top < 0;
            let show2 = modalBodyH - modalBodyP - $mainWrapper.position().top + 10 > 0;

            if (!show1 || !show2) {
                this.messageShowScroll = false;
            } else if (show1 && show2) {
                this.messageShowScroll = true;
            }

            this.messageTop = $mainWrapper.position().top - 25;
        }
    };

    public inputKeydown = (e: KeyboardEvent, inputNumber: number): void => {
        // console.log(e, inputNumber, 'inputKeydown');
        if (e && e.keyCode === 9 && e.shiftKey && !e.repeat){
            if (inputNumber === 4 || inputNumber === 3 ) {
                this.filterService.setGoToNextFilter2({ GUID: this.GUID, focus: new Focus(this.param, 'prev') });
                e.preventDefault();
                return;
            }
        }

        if (e && e.keyCode === 9 && !e.repeat){
            if (inputNumber === 3 || inputNumber === 2 || this.inputType !== '7' && inputNumber === 1) {
                this.filterService.setGoToNextFilter2({ GUID: this.GUID, focus: new Focus(this.param, 'next') });
                e.preventDefault();
                return;
            }
        }

        if(e && e.keyCode === 9 && e.repeat) {
            e.preventDefault();
        }
    }

}




// WEBPACK FOOTER //
// ./src/app/stocks/components/number-filter.component/number-filter.component.ts